import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import de from "./de";
import en from "./en";
import fr from "./fr";
import it from "./it";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { de: { translation: de }, en: { translation: en }, fr: { translation: fr }, it: { translation: it } },
    fallbackLng: "en",
    supportedLngs: ["de", "en", "fr", "it"],
    load: "languageOnly",
    interpolation: { escapeValue: false },
    detection: { order: ["localStorage", "navigator"], caches: ["localStorage"] },
  });

export default i18n;
